import { render, staticRenderFns } from "./ProjectZh.vue?vue&type=template&id=24229279&scoped=true&"
import script from "./ProjectZh.vue?vue&type=script&lang=js&"
export * from "./ProjectZh.vue?vue&type=script&lang=js&"
import style0 from "./ProjectZh.vue?vue&type=style&index=0&id=24229279&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24229279",
  null
  
)

export default component.exports